import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@tenancy.nz/ui';
import SkeletonContent from '../../ui/skeleton-content';
import useRouteBreadcrumbs from '../../hooks/use-route-breadcrumbs';

function BreadcrumbsFeature() {
  const {crumbs, loading} = useRouteBreadcrumbs();

  if (crumbs.length < 2) {
    return null;
  }

  const options = crumbs.map(({label, href, active}) => ({
    label,
    href,
    active,
    ...(href && !active && {component: RouterLink, to: href}),
  }));

  return (
    <Box px={{xs: 4, md: 8}} pt={{xs: 4, md: 8}} mb={{xs: -3, md: -7}}>
      <SkeletonContent loading={loading} height={24} width="20%">
        <Breadcrumbs options={options} />
      </SkeletonContent>
    </Box>
  );
}

export default BreadcrumbsFeature;
